import React from 'react';

const Tier1Provider = (props) => {
    const providerImageUrl = props.provider.images.picker.href || '';

    return (
        <li onClick={(event) => { event.preventDefault(); return props.providerSelect(props.provider); }}>
            <a><img src={providerImageUrl} alt={props.provider.name} /></a>
        </li>
    );
};

Tier1Provider.propTypes = {
    provider: React.PropTypes.object,
    providerSelect: React.PropTypes.func
};

export default Tier1Provider;



// WEBPACK FOOTER //
// ./app/modal/authn/Tier1Provider.js